import commify from '../../modules/ajio-util/commify.js';

export function setCartData(cart = {}, response = {}) {
  const {
    code = '',
    guid = '',
    freeDeliveryBannerUrl: pageBanner = '',
    giftWrapCharges = {},
    subTotal = {},
    totalPrice = {},
    totalTax = {},
    voucherAmount = {},
    deliveryItemsQuantity = 0,
    deliveryAddress = {},
    deliveryCost = {},
    pickupItemsQuantity = 0,
    totalItems = 0,
    totalUnitCount = 0,
    entries: cartItem = [],
    orderSummary = {},
    displayGiftWrapOption = true,
    pickupNode = '',
    deliveryModeValue = '',
    customerMobilePick = '',
    customerNamePick = '',
    giftRecepientName = '',
    giftSenderName = '',
    giftWrapMessage = '',
    cartValueLimitNew = {},
    cartValueLimit = {},
    serviceError = {},
    appliedProductPromotions = {},
    deliveryFeeThresholdAmount,
    stockStatus = {},
    pancard = {},
    age = 0,
    codEligible,
    pinCode = '',
    servicability,
    priorityDeliveryAlertMessage = '',
    errorMessages=[],
    membershipBenefitResponse=null,
    rushDeliveryApplied=false,
    gstDetails = {}, 
  } = response;

  cart = {
    ...cart,
    code,
    guid,
    pageBanner,
    totalUnitCount,
    deliveryFeeThresholdAmount,
    totalItems,
    pickupItemsQuantity,
    orderSummary,
    priceInfo: {
      subTotal,
      totalTax,
      totalPrice,
      voucherAmount,
      giftWrapCharges
      // promotionAmount
    },
    deliveryInfo: {
      deliveryAddress,
      deliveryItemsQuantity,
      deliveryCost,
      pickupNode,
      deliveryModeValue,
      customerMobilePick,
      customerNamePick
    },
    displayGiftWrapOption,
    giftRecepientName,
    giftSenderName,
    giftWrapMessage,
    cartValueLimitNew,
    cartValueLimit,
    serviceError,
    appliedProductPromotions,
    stockStatus,
    pancard,
    age,
    codEligible,
    pinCode,
    servicability,
    priorityDeliveryAlertMessage,
    errorMessages,
    membershipBenefitResponse,
    rushDeliveryApplied,
    gstDetails
  };
  /**
   * If customer has requested for the gift wrap for the cart
   *  giftWrapCharges.value > 0.
   */
  // let {value = 0} = giftWrapCharges;
  // if(parseInt(value) > 0) {
  //     let {
  //         giftRecepientName = "",
  //         giftSenderName = "",
  //         giftWrapMessage = ""
  //     } = response;
  //     if(giftRecepientName && giftSenderName) {
  //         cart = {
  //             ...cart,
  //             giftWrapInfo: {
  //                 receipent: giftRecepientName,
  //                 sender: giftSenderName,
  //                 message: giftWrapMessage,
  //                 amount: value
  //             }
  //         }
  //     }
  // }

  if (response.hasOwnProperty('rvpReturnFee')) {
    // this is for the retrun fee processing
    cart = { ...cart, rvpReturnFee: response.rvpReturnFee };
  }

  if (response.hasOwnProperty('appliedVouchers')) {
    const { appliedVouchers = [] } = response;
    cart = { ...cart, appliedVouchers };
  }

  return cart;
}
